module.exports = __webpack_public_path__ + "img/about-office-img-5.0a8c25fc.jpg";